import { useState, useEffect } from 'preact/hooks'
import React from 'react'
import { updateAdditionalCoverageAction } from '../../actions/UserData'
import { getCoveragePrice } from '../../utilities/combined-common'
import PropTypes from 'prop-types'

export const SliderButton = (props) => {
    
    const [toggled, setToggled] = useState(props.initialSlider)

    useEffect(() => {
        if(!props.checked[props.insuranceName]){
            if(toggled[props.item.displayName]) {
                setToggled((prev) => ({
                    ...prev,
                    [props.item.displayName] : false
                }))

                const data = {}
                data[props.item.name] = false;

                props.dispatch(updateAdditionalCoverageAction({...data}));
            }
        }
    }, [props.checked])

    const handleSlide = (item) => {
        setToggled((prevToggled) => ({
            ...prevToggled,
            [item.displayName || item.name]: !toggled[item.displayName || item.name]
        }))
        
        const tprice = props.userData.totalPrice;
    
        const additionalCoverageKey = `additionalCoverage-${props.insuranceName}`;
        const actionPayload = [item.package];
        const currentState = props.userData[additionalCoverageKey] || [];
        const data = {};
        let totalPackagePrice = props.userData[`totalPrice-${props.insuranceName}`] ? props.userData[`totalPrice-${props.insuranceName}`]
                                                                                    : 0;
        let newTotalCost;
        data[item.name] = false;
        let updatedState;
        if (!toggled[item.displayName || item.name]) {
            props.setAddCov((prev) => ({
                ...prev,
                [props.insuranceName]: true
              }));
            updatedState = [...currentState, ...actionPayload];
            data[item.name] = true;
            newTotalCost = tprice + getCoveragePrice(item.coveragePrice, props.userData)
            totalPackagePrice = totalPackagePrice + getCoveragePrice(item.coveragePrice, props.userData)
          } else {
            props.setAddCov((prev) => ({
                ...prev,
                [props.insuranceName]: false
              }));
            updatedState = currentState.filter(val => val !== actionPayload[0]);
            newTotalCost = tprice - getCoveragePrice(item.coveragePrice, props.userData)
            totalPackagePrice = totalPackagePrice - getCoveragePrice(item.coveragePrice, props.userData)
          }
        const payload = { [additionalCoverageKey]: updatedState };
        data[`totalPrice-${props.insuranceName}`] = totalPackagePrice;
        props.setValues({
            ...props.values,
            initialCost: newTotalCost,
            totalPrice: newTotalCost
        });
        props.dispatch(updateAdditionalCoverageAction({ ...payload, ...data, totalPrice: newTotalCost }));
    }

    return (
        <div className="additional_coverages_toggle_button">
            <anchor-button 
                className={`additional_coverages_toggle_button_main${toggled[props.item.displayName || props.item.name] ? '__toggled' : ''}`} 
                onClick={(e) => handleSlide(props.item)}
            />
            <anchor-button 
                className={`additional_coverages_toggle_circle${toggled[props.item.displayName || props.item.name] ? '__toggled' : ''}`} 
                onClick={(e) => handleSlide(props.item)}
            />
        </div>
    )
}

SliderButton.propTypes = {
    initialSlider: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    userData: PropTypes.object.isRequired,
    insuranceName: PropTypes.string,
    setAddCov: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    checked: PropTypes.func.isRequired
};